export default __webpack_public_path__ + "static/media/multichain.b92a617a.svg";